import GenericDialog from "../../../../../ui/dialogs/generic-dialog/GenericDialog";
import {AccordionDetails, AccordionSummary, Button, TextField, Typography} from "@material-ui/core";
import PropTypes from "prop-types";
import {useEffect} from "react";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import AddIcon from '@material-ui/icons/Add';
import SearchIcon from '@material-ui/icons/Search';
import LoadingBoxSkeletons from "../../../../../../shared/components/loading-box-skeletons/CardsSkeleton";
import GrayHeaderCard from "../../../../../ui/cards/gray-header-card/GrayHeaderCard";
import InputAdornment from "@material-ui/core/InputAdornment";
import {Accordion} from "./FaqDialogHelper";
import {useFaqDialog} from "./useFaqDialog";

const FaqDialog = (props) => {
    const [
        accordionData,
        loadingAccordionData,
        searchText,
        handleSearchChange,
        handleSearchKeyPress,
        fetchFaqs
    ] = useFaqDialog();

    useEffect(() => {
        fetchFaqs("");
    }, [fetchFaqs])

    const dialogContent = (
        <>
            <Typography variant="h5">F.A.Q</Typography>

            <Typography variant="body2">
                Qui troverai le risposte alle domande più frequenti, in caso tu non dovessi riuscire a
                trovare l’informazione che stai cercando, potrai <u>aprire una segnalazione</u>
                &nbsp;o <u>parlare con un operatore</u>
            </Typography>

            <GrayHeaderCard
                title={<Typography variant="subtitle2">Ricerca per parola chiave</Typography>}
            >
                <TextField
                    style={{marginBottom: '1em'}}
                    fullWidth
                    value={searchText}
                    onChange={handleSearchChange}
                    onKeyPress={handleSearchKeyPress}
                    placeholder="Cerca"
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <SearchIcon color="primary"/>
                            </InputAdornment>
                        ),
                    }}
                />
            </GrayHeaderCard>

            {loadingAccordionData ?
                <LoadingBoxSkeletons direction="vertical" height={40} count={4}/> : <div>
                    {accordionData.map((acc, indx) => ((
                        <Accordion
                            key={`faq-accordion-${indx}`}>
                            <AccordionSummary
                                style={{
                                    backgroundColor: '#efeff5',
                                    borderRadius: '15px',
                                    borderBottom: 'none'
                                }}
                                expandIcon={<AddIcon/>}
                            >
                                <Typography variant="subtitle2">{acc.title}</Typography>
                            </AccordionSummary>
                            <AccordionDetails
                                style={{borderRadius: '15px', borderBottom: 'none'}}
                            >
                                <Typography variant="body2">
                                    {acc.description}
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                    )))}
                </div>
            }
        </>
    );

    return (
        <GenericDialog
            dialogWidth="md"
            open={props.open}
            handleDialogClose={props.close}
            handleDialogCloseButton={props.close}
            dialogContent={dialogContent}
        >
            <Button variant="text"
                    color="secondary"
                    onClick={props.close}
                    startIcon={<ArrowBackIcon/>}>
                Indietro
            </Button>
        </GenericDialog>
    )
}

FaqDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired
}

export default FaqDialog;
